var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagName,{tag:"component",style:(_vm.buttonStyle),on:{"mouseover":function($event){_vm.isButtonHovered = true},"mouseleave":function($event){_vm.isButtonHovered = false},"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_vm._v("\n  "+_vm._s(_vm.content)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }